import { DotsSixVerticalIcon, DotsThreeIcon, PencilSimpleIcon } from '@phosphor-icons/react'

import { FieldSkeleton } from '@/components/layout/field-row'
import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'

import * as S from './linked-column.styled'

// Note: both text lines are the same width
const TEXT_WIDTH = '60%'

// Note: same box and line heights as LinkedRow (title 2rem, subtitle 1.6rem, 3.2rem menu button),
// so the list does not change height when the data arrives. Only the text is a skeleton - the drag
// handle, edit and menu buttons are the real controls, disabled.
interface LinkedRowSkeletonProps {
  // Note: the same buttons the loaded row has, disabled
  hasEdit: boolean
  hasMenu: boolean
  sortable: boolean
}

export const LinkedRowSkeleton = ({ hasEdit, hasMenu, sortable }: LinkedRowSkeletonProps) => (
  <S.SkeletonRow aria-hidden $selected={false}>
    {sortable && (
      <S.SkeletonDragHandle>
        <Icon icon={DotsSixVerticalIcon} size="1.6rem" />
      </S.SkeletonDragHandle>
    )}
    <S.RowMain as="div">
      <FieldSkeleton height="2rem" width={TEXT_WIDTH} />
      <FieldSkeleton height="1.6rem" width={TEXT_WIDTH} />
    </S.RowMain>
    {(hasEdit || hasMenu) && (
      <S.RowActions>
        {hasEdit && (
          <Button disabled onlyBox size="small" use="primary-light">
            <Icon icon={PencilSimpleIcon} />
          </Button>
        )}
        {hasMenu && (
          <Button disabled onlyBox size="small" use="primary-light">
            <Icon icon={DotsThreeIcon} weight="bold" />
          </Button>
        )}
      </S.RowActions>
    )}
  </S.SkeletonRow>
)
